import { useCallback, useMemo } from 'react';
import { useFirestorePageQuery } from '@/hooks/useFirestorePageQuery';

export type PartyOption = { id: string; code: string; name: string; balance: string };

export function usePaginatedPartySelect(orgId: string | null, type: 'customers' | 'vendors') {
  const mapDoc = useCallback(
    (id: string, data: { code?: string; name?: string; balance?: string }) => ({
      id,
      code: String(data.code ?? ''),
      name: String(data.name ?? ''),
      balance: String(data.balance ?? '0.00')
    }),
    []
  );

  const page = useFirestorePageQuery<PartyOption>({
    orgId,
    collectionPath: type,
    orderByField: 'name',
    orderDirection: 'asc',
    mapDoc
  });

  const selectOptions = useMemo(
    () => page.rows.map((p) => ({ value: p.id, label: p.name })),
    [page.rows]
  );

  return { ...page, selectOptions, parties: page.rows };
}
